/**
 * EditButton Handler для форм ресурсів
 * 
 * Додає кнопку "Редагувати" що переключає режим з view на edit
 */

import React from 'react'
import { MdOutlineEdit } from 'react-icons/md'
import type { IFormButtonHandlerParams } from '../../types'

/**
 * Додає кнопку "Редагувати"
 * Відображається в режимі перегляду, коли є права на оновлення
 * 
 * @param params - параметри з buttons та crudContext
 */
export const EditButton = ({ buttons, crudContext }: IFormButtonHandlerParams) => {
    buttons['edit'] = {
        sort: 1000,
        icon: React.createElement(MdOutlineEdit),
        depFn: () => {
            if (!crudContext || !crudContext.formContext) return false
            if (!crudContext.actions || typeof crudContext.actions.edit !== 'function') return false
            return (
                !crudContext.formContext.isEditable &&
                crudContext.formContext.values?.['@id']?.length > 0 &&
                crudContext.accessFn &&
                typeof crudContext.accessFn === 'function' &&
                crudContext.accessFn({
                    accessMode: 'update',
                    accessItem: crudContext.formContext.values,
                    crudContext: crudContext,
                })
            )
        },
        priority: 'button',
        size: 'middle',
        onClick: () => {
            if (crudContext?.actions?.edit && crudContext?.formContext?.values) {
                crudContext.actions.edit(crudContext.formContext.values)
            }
        },
        label: 'Редагувати',
    }
}
